import { useState } from 'react';
import { ToastContainer, toast,Bounce } from 'react-toastify';


function Contact() {
  const [formData, setFormData] = useState({
    client_name: '',
    client_email: '',
    client_phone: '',
    service_required: '',
    message: '',
  });
  const [disabled,setDisabled] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        setDisabled(true);
        formData.p_id = '1004'  
        
      const res = await fetch('https://commandx-backend.vercel.app/mail/contactmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setDisabled(false);
        toast.success('Your message has been sent!', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        setFormData({ client_name: '', client_email: '', client_phone: '', message: '' });
      } else {
        setDisabled(false);
        toast.error('Failed to send message!', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
      }
    } catch (err) {
      //console.error('Error sending message:', err);
      toast.error('Failed to send message!', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2>Contact Us</h2>
        <p>We'd love to hear from you. Please fill out the form below.</p>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="client_name"
              placeholder="Your Name"
              value={formData.client_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="client_email"
              placeholder="you@example.com"
              value={formData.client_email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="client_phone"
              placeholder="e.g. +9199XXXXXXXX"
              value={formData.client_phone}
              onChange={handleChange}
            />
          </div>
          <div className="form-group full">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              placeholder="Write your message..."
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <div className="form-group full">
            <button type="submit" disabled={disabled}>Send Message</button>
          </div>
        </form>
      </div>
      <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Bounce}
            />
    </section>
  );
}

export default Contact;
